import React from 'react';
import '../scss/ControlSelector.css';
// import { Link } from 'react-router-dom'
// import IconArrowLeft from '../icons/IconArrowLeft'
// import IconArrowRight from '../icons/IconArrowRight'

// const ControlSelector = (props) => (
class ControlSelector extends React.Component {
  constructor (props) {
    super(props)
    // ...
    this.ulRef = React.createRef()
    // @todo: arreglar esto. Fago así xq se executa 2 veces...
    this.componentDidUpdateCount = 0
  }

  animatedScroll (dom, delta) {
    const x0 = dom.scrollLeft
    const SCROLL_DURATION = 30
    const stepX = Math.PI / SCROLL_DURATION
    let stepCount = 0

    const step = function () {
      if (stepCount < SCROLL_DURATION) {
        window.requestAnimationFrame(step)
        stepCount++
        // console.info(x0 + 0.25 * delta * Math.pow((1 - Math.cos(stepX * stepCount)), 2))
        dom.scrollTo(x0 + 0.25 * delta * Math.pow((1 - Math.cos(stepX * stepCount)), 2), 0)
      }
    }
    window.requestAnimationFrame(step)
  }

  scrollLeft () {
    if (this.ulRef.current) {
      this.animatedScroll(this.ulRef.current, -300)
    }
  }

  scrollRight () {
    if (this.ulRef.current) {
      this.animatedScroll(this.ulRef.current, 300)
    }
  }

  componentDidUpdate (prevProps, prevState) {
    if (parseInt(prevProps.controlId, 10) !== parseInt(this.props.controlId, 10)) {
      if (this.ulRef.current && this.props.controlId) {
        this.ulRef.current.childNodes.forEach(e => {
          if (parseInt(e.getAttribute('data-id'), 10) === parseInt(this.props.controlId, 10)) {
            const position = e.offsetLeft - this.ulRef.current.offsetLeft -
              this.ulRef.current.scrollLeft - (this.ulRef.current.offsetWidth / 2 - e.offsetWidth / 2)
            this.animatedScroll(this.ulRef.current, position)
          }
        })
      }
    }
  }

  render () {
    // console.info('render')
    const controlId = parseInt(this.props.controlId, 10)
    const controlList = this.props.controlList

    return <div className='control-selector'>
      <ul className='control-selector__ul' ref={this.ulRef}>
        {controlList.map((control) => {
          // ...
          let selected = ''
          if (parseInt(control.id, 10) === controlId) {
            selected = 'control-selector__item--selected'
          }
          // Nunca mostramos el control de salida
          if (control.tipo === 'SALIDA') {
            return null
          } else {
            return <li key={control.id} className={'control-selector__item ' + selected} data-id={control.id}>
              <button onClick={() => { this.props.navigateToControl(control.id) }}>
                <div>{control.nombre}</div>
                <div
                  className={'control-selector__item__nombre'}
                  dangerouslySetInnerHTML={{ __html: control.descripcion ? (control.descripcion) : ('&nbsp;') }}
                />
              </button>
            </li>
          }
        })}
      </ul>
      <div className={'control-selector__shadow-left'} />
      <div className={'control-selector__shadow-right'} />
      {/*
      <button className='control-selector__btn-left' onClick={this.scrollLeft.bind(this)}>
        <IconArrowLeft />
      </button>
      <button className='control-selector__btn-right' onClick={this.scrollRight.bind(this)}>
        <IconArrowRight />
      </button>
      */}
    </div>
  }
}
// )

export default ControlSelector



// WEBPACK FOOTER //
// ./src/components/ControlSelector.js